// src/components/ScrollToTop.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  // Get the current page "pathname" (e.g., "/about")
  const { pathname } = useLocation();

  // This "effect" runs every time the 'pathname' changes
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll the window to the top
  }, [pathname]); // The dependency array: runs only when pathname changes

  return null; // This component renders no HTML
}

export default ScrollToTop;